export default "__VITE_ASSET__w25U$T6i__";